export default __webpack_public_path__ + "static/media/d1.343675d9.png";